/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'checkmark': {
    width: 32,
    height: 24,
    viewBox: '0 0 32 24',
    data: '<path pid="0" d="M10.142 18.977L29.421 0 32 2.533 10.142 24 0 14.04l2.536-2.534z" _fill="#000" fill-rule="nonzero"/>'
  }
})
